<template>
  <div class="doughnut-chart">
    <doughnut 
      :data="chartData" 
      :options="chartOptions"
    />
  </div>
</template>

<script>
import { Doughnut } from 'vue-chartjs';
import { Chart as ChartJS, DoughnutController, ArcElement, Legend, Tooltip } from 'chart.js';
import 'chartjs-adapter-moment';
import UtilsMixin from '@/mixins/UtilsMixin';

ChartJS.register(DoughnutController, ArcElement, Legend, Tooltip);

export default {
    name: "DoughnutChart",
    mixins: [UtilsMixin],
    components: {
        Doughnut
    },

    props: {
        client: {
            type: Object,
            required: true,
        },
        employee: {
            type: Object,
            required: false,
        },
        organization: {
            type: Object,
            required: false,
        },
        distributions: {
            type: Array,
            required: false,
        },
    },

    data() {
        return {
            chartData: {},
            chartOptions: {
                animation: false,
                cutout: '60%',
                plugins: {
                    legend: {
                        position: 'right',
                        labels: {
                            usePointStyle: 'true',
                            color: '#071820',
                            font: {
                                size: 14,
                            }
                        },
                        onClick: function() { } // prevent the data being hidden when legend is clicked
                    },
                    tooltip: {
                        callbacks: {
                            label: function(context) {
                                return context.parsed * 100 + '%'
                            }
                        },
                        displayColors: false,
                    }
                },
            },
            clientColors: {
                highlight: null,
                foreground: null,
                background: null,
            },
        }
    },

    computed: {
      orgUnits() {
        if(this.distributions.length) return this.distributions[this.distributions.length - 1].org_units
        else return this.organization.units
      },
    },

    created() {
        this.buildChartData()
    },

    mounted() {},

    methods: {
        getSliceColors() {
            let root_element = document.querySelector(':root')
            let [r, g, b] = root_element.style.cssText.split('--brand-color: rgb(')[1].split(')')[0].split(' ');

            let minOpacity = 30;
            let maxOpacity = 70;
            let stepCount = Object.values(this.organization.types).filter(({weight}) => weight > 0).length + (this.employee.performance.mode == 'as-component' ? 1 : 0);
            let opacityStep = (maxOpacity - minOpacity) / (stepCount > 1 ? stepCount - 1 : stepCount);

            let unitColors = [];
            for (let i = 0; i < stepCount; i++) {
                let tint = this.RGBTint(parseInt(r), parseInt(g), parseInt(b), (maxOpacity - (opacityStep * i)) / 100);
                unitColors.push(this.RGBToHex(tint.r, tint.g, tint.b));
            }
            unitColors.reverse();

            let slices = [];

            if(this.client) {
                slices.push(this.RGBToHex(r, g, b))
            }

            if(this.organization?.types) {
                let totalTypes = Object.values(this.organization.types).filter(({weight}) => weight > 0).length

                for(let index = 0; index < totalTypes; index++) {
                    slices.push(unitColors[index])
                }
            }

            if(this.employee.performance.mode == 'as-component') {
                slices.push(unitColors[unitColors.length - 1])
            }

            return slices;
        },
        buildChartData() {
            this.chartData = {
                labels: [],
                datasets: [
                    {
                        data: [],
                        backgroundColor: this.getSliceColors(),
                    }
                ]
            }
            this.chartData.labels.push(this.client.allocation.label)
            this.chartData.datasets[0].data.push(this.client.allocation.weight / 10000000)

            if(Object.values(this.orgUnits).length) {
                Object.values(this.orgUnits).forEach((unit) => {
                    let label = `${this.distributions.length ? unit.label : this.organization.types[unit.type_id].label}`
                    let weight = null

                    if(unit?.allocation?.weight) {
                        weight = unit.allocation.weight
                    }
                    else if(unit?.weight) {
                        weight = unit.weight
                    }

                    this.chartData.labels.push(label)
                    this.chartData.datasets[0].data.push(weight / 10000000)
                })
            }

            if(this.employee.performance.mode == 'as-component') {
                this.chartData.labels.push(this.employee.allocation.label)
                this.chartData.datasets[0].data.push(this.employee.allocation.weight / 10000000)
            }
        },
    }
}
</script>

<style scoped>
</style>